import React from 'react';

const DashboardIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="11" cy="11" r="10" stroke="#555B67" strokeWidth="2" />
    <circle
      cx="11.0001"
      cy="11.0001"
      r="1.36364"
      stroke="#555B67"
      strokeWidth="2"
    />
    <path
      d="M7.36353 14.409L9.90898 11.8635"
      stroke="#555B67"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M11.9546 10.0454L14.7715 7.22852"
      stroke="#555B67"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default DashboardIcon;
